export default __webpack_public_path__ + "afd0ecccc087487cb51924092dc413f2.png";